import { LoginCallback } from '@okta/okta-react'
import React, { useEffect } from 'react'
import { Route, Switch, useHistory } from 'react-router-dom'
import { useAuth, usePermissions } from '../../hooks'
import { RoutesEnum } from '../../types/RoutesEnum'
import { ApexLogin } from '../ApexLogin'
import AppLayout from '../AppLayout'
import { AccountSearchPage } from '../../components/AccountSearch'
import { PermissionsEnum } from '../../constants'
import PermissionRoute from '../../components/PermissionRoute/PermissionRoute'
import { AccountDetailsPage } from '../AccountDetailsPage'
import { AccountSummaryPage } from '../AccountSummaryPage'
import { setRumSessionUser } from '../../utils/datadog'

export const App = () => {
  const { showAppContent } = useAuth()
  const history = useHistory()
  const { hasPermission, permissionsLoading } = usePermissions()
  const minimumPermissions = [
    PermissionsEnum.AccountRead,
  ]
  const hasMinimumPermissions = minimumPermissions.every(hasPermission)
  
  useEffect(() => {
    const {
      location: { pathname },
    } = history
    
    setRumSessionUser()
    if (!permissionsLoading && hasMinimumPermissions && pathname === '/') {
      history.replace(`/${RoutesEnum.AccountSummary}`)
    }
  }, [
    permissionsLoading,
    history,
    hasMinimumPermissions,
    history.location.pathname,
  ])


  return (
    <AppLayout>
      {showAppContent ? (
        <>
          <Route path="/" component={LoginCallback} />
          <Switch>
            <PermissionRoute
              path={`/${RoutesEnum.AccountDetails}/:accountNumber`}
              component={AccountDetailsPage}
              requiredPermissions={minimumPermissions}
            />
            <PermissionRoute
              path={`/${RoutesEnum.AccountSummary}/:accountNumber`}
              component={AccountSummaryPage}
              requiredPermissions={minimumPermissions}
            />
            <PermissionRoute
              path={`/${RoutesEnum.AccountSummary}`}
              component={AccountSearchPage}
              requiredPermissions={minimumPermissions}
            />
            <PermissionRoute
              path={`/`}
              component={AccountSearchPage}
              requiredPermissions={minimumPermissions}
            />
          </Switch>
        </>
      ) : (
        <ApexLogin />
      )}
    </AppLayout>
  )
}
